module.exports = __webpack_public_path__ + "img/29.5ad07b98.jpg";